<template>
  <v-app id="app">
    <!-- <Header
      system-name="ระบบสถิติ"
      program-name="การตรวจสอบข้อมูลสถิติทางการทะเบียนอัตโนมัติ"
      :version="require('../package.json').version"
      :clerk-name= clerkName
      :work-place= workPlace
      background-color="deep-purple"
      /> -->
    <v-layout v-if="this.$route.name == 'FilterPage'" class="BG1">
      <v-content>
        <router-view :key="$route.fullPath" />
      </v-content>
    </v-layout>
    <v-layout v-if="this.$route.name == 'TableAge'" class="BG2">
      <v-content>
        <router-view :key="$route.fullPath" />
      </v-content>
    </v-layout>
    <v-layout v-if="this.$route.name == 'FilterPageAge'" class="BG1">
      <div class="aa">

      </div>
      <div class="bb">
        <v-content>
          <router-view :key="$route.fullPath" />
        </v-content>
      </div>
    </v-layout>
    <v-layout
      v-if="
        this.$route.name != 'FilterPage' && this.$route.params.id == 'statpop'
      "
      class="BG2"
    >
      <v-flex xs1> </v-flex>
      <v-flex xs10>
        <v-content>
          <router-view :key="$route.fullPath" />
        </v-content>
      </v-flex>
    </v-layout>

    <v-layout
      v-if="
        this.$route.name != 'FilterPage' &&
          this.$route.params.id == 'statpophse'
      "
      class="BG2"
    >
      <v-flex xs1> </v-flex>
      <v-flex xs10>
        <v-content>
          <router-view :key="$route.fullPath" />
        </v-content>
      </v-flex>
    </v-layout>
    <v-layout
      v-if="
        this.$route.name != 'FilterPage' && this.$route.params.id == 'stathouse'
      "
      class="BG2"
    >
      <v-flex xs1> </v-flex>
      <v-flex xs10>
        <v-content>
          <router-view :key="$route.fullPath" />
        </v-content>
      </v-flex>
    </v-layout>
    <v-layout
      v-if="
        this.$route.name != 'FilterPage' && this.$route.params.id == 'statbirth'
      "
      class="BG2"
    >
      <v-flex xs1> </v-flex>
      <v-flex xs10>
        <v-content>
          <router-view :key="$route.fullPath" />
        </v-content>
      </v-flex>
    </v-layout>
    <v-layout
      v-if="
        this.$route.name != 'FilterPage' && this.$route.params.id == 'statdeath'
      "
      class="BG2"
    >
      <v-flex xs1> </v-flex>
      <v-flex xs10>
        <v-content>
          <router-view :key="$route.fullPath" />
        </v-content>
      </v-flex>
    </v-layout>

    <v-layout
      v-if="
        this.$route.name != 'FilterPage' &&
          this.$route.params.id == 'statmovein'
      "
      class="BG2"
    >
      <v-flex xs1> </v-flex>
      <v-flex xs10>
        <v-content>
          <router-view :key="$route.fullPath" />
        </v-content>
      </v-flex>
    </v-layout>

    <v-layout
      v-if="
        this.$route.name != 'FilterPage' &&
          this.$route.params.id == 'statmoveout'
      "
      class="BG2"
    >
      <v-flex xs1> </v-flex>
      <v-flex xs10>
        <v-content>
          <router-view :key="$route.fullPath" />
        </v-content>
      </v-flex>
    </v-layout>

    <v-layout
      v-if="
        this.$route.name != 'FilterPage' &&
          this.$route.params.id == 'statdeathAge'
      "
      class="BG2"
    >
      <v-flex xs1> </v-flex>
      <v-flex xs10>
        <v-content>
          <router-view :key="$route.fullPath" />
        </v-content>
      </v-flex>
    </v-layout>
  </v-app>
</template>

<script>
import NavDrawer from "./components/NavDrawer";
import axios from "axios";

export default {
  data() {
    return {
      systemDate: "",
      currentComponent: null,
      items: [
        { text: "ประชากรทะเบียนบ้าน", name: "FilterPage" },
        { text: "บ้านจากทะเบียนบ้าน" },
        { text: "การเกิดจากสูติบัตร" },
        { text: "การตายจากมรณบัตร" },
        { text: "การยายออกจากใบแจ้งย้ายออก" },
        { text: "การย้ายเข้าจากใบาแจ้งย้ายเข้า" },
        { text: "การแก้ไขและจำหน่ายชื่อบุคคลโดย ทร.971และ ทร.44" },
        { text: "การแก้ไขและเพิ่มชื่อบุคคลโดย ทร 14" },
        { text: "การแก้ไขและเพิ่มชื่อบุคคลโดย ทร.98" },
        { text: "ทะเบียนเพิ่มบ้านใหม่ ทร.99" },
        { text: "รวมทุกทะเบียน" },
      ],
      clerkName: null,
      OfficerName: null,
      workPlace: null,
      date: null,
    };
  },
  created() {
  },
  components: {
    NavDrawer,
  },
};
document.documentElement.style.overflow = "scroll"; // firefox, chrome
document.body.scroll = "no"; // ie only
</script>

<style>
.BG1 {
  background: url("./assets/BGststinterneEmernaldt.png");
  height: 100%;
  background-position: center;
  background-repeat: no-repeat;
  background-size: cover;
}

.BG2 {
  background: url("./assets/BGstatpop.png");
  height: 100%;
  background-position: center;
  background-repeat: no-repeat;
  background-size: cover;
  background-attachment: fixed;
}
.BG3 {
  background: url("./assets/BGstatpophse.png");
  height: 100%;
  background-position: center;
  background-repeat: no-repeat;
  background-size: cover;
}

.BG4 {
  background: url("./assets/BGstathouse.png");
  height: 100%;
  background-position: center;
  background-repeat: no-repeat;
  background-size: cover;
}

.BG5 {
  background: url("./assets/BGstatbirth.png");
  height: 100%;
  background-position: center;
  background-repeat: no-repeat;
  background-size: cover;
}

.BG6 {
  background: url("./assets/BGstatdeath.png");
  height: 100%;
  background-position: center;
  background-repeat: no-repeat;
  background-size: cover;
}

.BG7 {
  background: url("./assets/BGstatmovein.png");
  height: 100%;
  background-position: center;
  background-repeat: no-repeat;
  background-size: cover;
}

.BG8 {
  background: url("./assets/BGstatmoveout.png");
  height: 100%;
  background-position: center;
  background-repeat: no-repeat;
  background-size: cover;
}

@font-face {
  font-family: "CSChatThaiUI";
  src: url("./fonts/CSChatThaiUI.woff") format("woff");
}
* {
  font-family: "CSChatThaiUI";
  font-size: 16px;
}
.v-textarea textarea {
  padding-bottom: 1 px;
  padding-top: 1px;
}
.component-fade-enter-active,
.component-fade-leave-active {
  transition: opacity 0.2s ease;
}
.component-fade-enter,
.component-fade-leave-to {
  opacity: 0;
}
hr {
  background-color: #10b1f7;
  height: 2px;
  border: none;
}
label {
  color: #10b1f7;
  font-weight: bold;
}
.v-input input,
.v-menu__activator {
  max-height: 25px;
}
.v-input .v-label {
  width: auto;
  font-size: 14px;
  color: #10b1f7;
}
.v-text-field .v-label {
  width: auto;
  color: #030303;
  font-size: 20px;
  line-height: 26px;
  height: auto;
}
.v-text-field .v-label--active {
  max-width: none;
  font-size: 18px;
}
.v-text-field {
  margin-top: 8px;
}
.v-textarea.v-text-field--box.v-text-field--single-line .v-text-field__prefix,
.v-textarea.v-text-field--box.v-text-field--single-line textarea,
.v-textarea.v-text-field--enclosed.v-text-field--single-line
  .v-text-field__prefix,
.v-textarea.v-text-field--enclosed.v-text-field--single-line textarea {
  margin-top: 0px;
}
.v-input--radio-group .v-input__control .v-input__slot {
  margin-bottom: 0px;
}
.v-radio {
  align-items: flex-start;
}
.v-text-field .v-input__control .v-text-field__details,
.v-messages {
  display: none;
}
.select-label .v-select__selection {
  color: #000000;
  font-size: 16px;
}
.active {
  background: linear-gradient(
    to right,
    rgba(108, 201, 241, 0.5),
    rgba(11, 172, 242, 0.53)
  );
  color: rgb(16, 177, 247);
}
.component-fade-enter-active,
.component-fade-leave-active {
  transition: opacity 0.2s ease;
}
.component-fade-enter,
.component-fade-leave-to {
  opacity: 0;
}
.v-input--is-readonly > .v-input__control > .v-input__slot:before,
.v-input--is-readonly > .v-input__control > .v-input__slot:after {
  border-style: none;
}
.v-input--is-readonly
  > .v-input__control
  > .v-input__slot
  > .v-select__slot
  > .v-input__append-inner {
  display: none;
}
.aa {
  width: 50%;
}
.bb {
  width: 50%;
}
.cc {
  width: 10%;
}
@media (max-width: 768px) {
  .aa {
    width: 0%;
  }
  .bb {
    width: 100%;
  }
  .cc {
    width: 0%;
  }
  * {
    font-family: "CSChatThaiUI";
    font-size: 14px;
  }
}
/* .v-select__selection,.v-input {
    font-size: 14px;
  } */
</style>
